module.exports = __webpack_public_path__ + "img/vc.abf37c9a.svg";